import { create } from "zustand";
export const useChatSessionStore = create((set)=>({
        chatId: "",
        docId: null,
        isNewChat: false,
        applyingToolIds: [],
        setApplying: (toolCallId, isApplying)=>set((state)=>({
                    applyingToolIds: isApplying ? [
                        ...state.applyingToolIds,
                        toolCallId
                    ] : state.applyingToolIds.filter((id)=>id !== toolCallId)
                })),
        setSession: ({ chatId, docId })=>set({
                chatId,
                docId,
                isNewChat: false
            }),
        setChatId: (chatId)=>set({
                chatId
            }),
        setIsNewChat: (isNewChat)=>set({
                isNewChat
            })
    }));
